
// import { useEffect  } from 'react'
import { Newsfeed } from "../../Components/Newsfeed/newsfeed.component"
const News = () => {

    return (
        <div className="news-content">
            <Newsfeed/>
        </div>
    )
}

export default News